import { Component } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.css']
})
export class ConfiguracionComponent {

  //get i
  idRegistro
  idEncuesta
  idFormulario

  constructor(private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.idFormulario = params.get('idformulario');
      this.idEncuesta = params.get('idencuesta');
      this.idRegistro = params.get('idregistro');
    });
  }

}
